/* eslint-disable @typescript-eslint/no-explicit-any -- this file is in progress, many unknown typings still*/
import React from 'react';
import ConditionalInput from './../../shared/widgets/ConditionalInput';
// @ts-expect-error ts-2307
import { merge } from 'highed';
import { cloneDeep, get, isArray } from 'lodash';
import {
  extractOptionalArrayVal,
  extractRefersToVal,
  getFilteredValue,
  getIndexFromPath
} from './helpers/WidgetHelper';
import en from '../../editor/en';
import layoutEn from '../../pages/LayoutEditorPage/meta/en';
import tableEn from '../../pages/TableEditorPage/meta/en';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { OptionProps } from 'pages/ChartEditorPage/meta/CustomizeOptions';

export type BuildInputsProps = {
  overrideOnChange?: any;
  section?: any;
  overrideOptions?: any;
  loadPaginated?: (parent: Window, val: string) => void;
  customizedOptions?: any;
  parentKey?: string;
  parentPath?: string;
  overrideExtractValue?: any;
  editorConfig?: any;
  index?: string | number;
  showUndoButton?: boolean;
};

const langMap: Record<string, any> = {
  chart: en,
  layout: layoutEn,
  table: tableEn
};

export const keepWhiteBgMap = {
  string: 1
};

const EmptyContainer = (props: { children: React.ReactNode }) => <>{props.children}</>;
const PostFieldsContainer = (props: { children: React.ReactNode }) => <div className="bg-white">{props.children}</div>;

const BuildInputs = (props: BuildInputsProps) => {
  const { parentPath, section, parentKey, overrideOnChange } = props;

  const { type } = useSelector((state: RootState) => state.layoutEditorPage);
  const { chart }: { chart: any; isMap: boolean } = useSelector((state: RootState) => state.chartEditorPage);
  const {
    themeOptions,
    customizedOptions,
    aggregatedOptions: agg
  } = useSelector<any, any>((state: RootState) => state.projectConfig);
  let aggregatedOptions = agg;
  const lang = langMap[type ?? 'table'];
  if (type !== 'chart') {
    aggregatedOptions = merge(cloneDeep(themeOptions.options), cloneDeep(customizedOptions));
  }

  const aggregated =
    type === 'chart' && (chart?.options || chart?.userOptions)
      ? merge({}, chart.options ? chart.options : chart.userOptions)
      : merge({}, aggregatedOptions ?? {});

  const getSubtypeDefaultValue = (section: any, property: OptionProps) => {
    if (!property.subTypedefault) return;
    const index = getIndexFromPath(parentPath);
    const type = getFilteredValue(section, chart, index);
    return (property.subTypedefault as any)[type];
  };

  const extractValue = (aggregatedOptions: any, property: OptionProps) => {
    if (props.overrideExtractValue) return props.overrideExtractValue(property);
    const options = props.overrideOptions ?? aggregatedOptions ?? {};
    let val: unknown;
    if (property?.refersTo) {
      val = extractRefersToVal(chart, property);
    } else if (property?.isOptionalArray) {
      val = extractOptionalArrayVal(options, property);
    } else if (isArray(property?.id)) {
      val = get(options, property.id[0] ?? '');
    } else if (property?.useCustomizedOptions) {
      val = get(customizedOptions, property.id ?? '');
    } else val = get(options, property.id ?? '');

    return val ?? getSubtypeDefaultValue(section, property) ?? property.default ?? null;
  };

  const generatePostFields = (properties: any, optionChosen: any, index: number) => {
    let postFields = [];
    if (properties.postFields) {
      postFields = properties.postFields
        .map((p: OptionProps, i: number) => {
          const className = (p.type ?? '') in keepWhiteBgMap ? '' : 'bg-ev-grey';

          if (optionChosen === p.optionNeeded) {
            const postLabel = p.title ?? (lang.entries[`option.text.${p.pid}`] || lang.entries[p.pid ?? '']);
            return (
              <div key={`${section.id}_${index}_${i}`} className={`property ${p.optionNeeded} ${p.id}`}>
                <ConditionalInput
                  option={p}
                  aggregatedOptions={aggregated}
                  userAggregatedOptions={aggregatedOptions}
                  value={extractValue(aggregated, p)}
                  label={postLabel}
                  parent={parentKey ?? ''}
                  overrideOnChange={overrideOnChange}
                  parentPath={parentPath ?? ''}
                  showUndoButton={props.showUndoButton}
                  className={className}
                />
              </div>
            );
          }

          return null;
        })
        .filter((d: any) => d);
    }
    return postFields;
  };

  return (section.filteredOptions ?? section.options).map((properties: OptionProps, index: number) => {
    const label =
      properties.title ?? (lang.entries[`option.text.${properties.pid}`] || lang.entries[properties.pid ?? '']);
    const Container = properties.postFields ? PostFieldsContainer : EmptyContainer;
    const optionChosen = extractValue(aggregated, properties);
    const postFields = generatePostFields(properties, optionChosen, index);

    return (
      <React.Fragment key={`${section.id}_${index}`}>
        <Container>
          <ConditionalInput
            option={properties}
            aggregatedOptions={aggregated}
            userAggregatedOptions={aggregatedOptions}
            label={label}
            value={extractValue(aggregated, properties)}
            parent={parentKey ?? ''}
            overrideOnChange={overrideOnChange}
            parentPath={parentPath ?? ''}
            className={properties.className}
            index={props.index}
            showUndoButton={props.showUndoButton}
          />

          {properties.postFields && postFields.length > 0 && (
            <div className="option-properties relative flex flex-col rounded mx-4 py-2 pb-6">{postFields}</div>
          )}
        </Container>
      </React.Fragment>
    );
  });
};

export default BuildInputs;
